import type {
  AccordionContent,
  ExtraContent,
} from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxBenefits/types";

export default function insertElementsIntoBenefits(
  groupedBenefits: AccordionContent[],
  newItems: ExtraContent[],
): AccordionContent[] {
  newItems.forEach((newItem, index) => {
    const existingGroupIndex = groupedBenefits.findIndex(
      (group) => group.category === newItem.category,
    );

    if (existingGroupIndex !== -1) {
      groupedBenefits[existingGroupIndex].elements.push(newItem.element);
    } else {
      groupedBenefits.splice(
        newItem.position !== undefined
          ? newItem.position
          : groupedBenefits.length,
        0,
        {
          category: newItem.category,
          elements: [{ ...newItem.element, key: String(index) }],
        },
      );
    }
  });

  return groupedBenefits;
}
